let ShareUtil = {
  loadJs: function(src, callback) {
    let script = document.createElement('script'), loaded = false;
    script.setAttribute('src', src);

    if (script.readyState){  //IE
        script.onreadystatechange = function(){
          if (script.readyState == "loaded" ||
              script.readyState == "complete"){
              script.onreadystatechange = null;
                  if (!loaded) callback && callback();
                  loaded = true;
          }
      }
    } else {  //Others
        script.onload = function(){
            if (!loaded) callback && callback();
            loaded = true;
        };
    }

    // if (callback) {
    //   script.onreadystatechange = script.onload = function() {
    //     if (!loaded) callback();
    //     loaded = true;
    //   };
    // }
    document.getElementsByTagName( 'head' )[ 0 ].appendChild( script );
    return false;
  }
};

export default ShareUtil;
